import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7149d9ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "heading-xl" }
const _hoisted_2 = { class: "subheading" }
const _hoisted_3 = { class: "cards" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = ["href", "data-cy"]
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "content" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconArrowRight = _resolveComponent("IconArrowRight")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BaseWrapper = _resolveComponent("BaseWrapper")!

  return (_openBlock(), _createBlock(_component_BaseWrapper, { logoDisplay: true }, {
    default: _withCtx(() => [
      _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t('heading')), 1),
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('subHeading')), 1),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.destinationList, (destination) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: destination }, [
            (destination.permission === 'USERS' || destination.requiresMfa)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: "card-wrapper",
                  to: destination.requiresMfa ? { name: 'MFAVerify', query: { destinationUrl: destination.url }} : { path: destination.url },
                  "data-cy": _ctx.dataCy(destination.label)
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t(`destinationListLabels.${destination.permission}[${destination.translationIndex}]`)), 1)
                      ]),
                      _createVNode(_component_IconArrowRight, { class: "icon-arrow-right" })
                    ])
                  ]),
                  _: 2
                }, 1032, ["to", "data-cy"]))
              : (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  class: "card-wrapper",
                  href: destination.url,
                  "data-cy": _ctx.dataCy(destination.label)
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t(`destinationListLabels.${destination.permission}[${destination.translationIndex}]`)), 1)
                    ]),
                    _createVNode(_component_IconArrowRight, { class: "icon-arrow-right" })
                  ])
                ], 8, _hoisted_6))
          ], 64))
        }), 128))
      ]),
      _hoisted_9,
      _hoisted_10,
      _createVNode(_component_router_link, {
        class: "btn-ghost logout-btn",
        to: "/logout",
        "data-cy": "logout-link"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('logout')), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}